<template>
  <RevAccordionItem>
    <template #prefix>
      <IconAvatar />
    </template>
    <template #title>
      {{
        i18n(translations.title, {
          firstName: customer.firstName,
          lastName: customer.lastName,
        })
      }}
    </template>
    <template #description>{{ i18n(translations.description) }}</template>
    <template #body>
      <ul class="grid grid-cols-1 gap-16 lg:grid-cols-2">
        <li>
          <p class="font-weight-body-2-bold">
            {{ i18n(translations.shippingAddress) }}
          </p>
          <Address :address="orderline.shippingAddress" />
          <p class="text-static-default-low break-words">
            {{ orderline.customerShippingEmail }}
          </p>
        </li>
        <li>
          <p class="font-weight-body-2-bold">
            {{ i18n(translations.billingAddress) }}
          </p>
          <Address :address="orderline.billingAddress" />
          <p class="text-static-default-low break-words">
            {{ orderline.customerInvoiceEmail }}
          </p>
        </li>
      </ul>
    </template>
  </RevAccordionItem>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { IconAvatar } from '@ds/icons/IconAvatar'

import type { Customer, Orderline } from '~/api/care-folders/types/care-folder'

import Address from '../Address.vue'

import translations from './Customer.translations'

defineProps<{
  customer: Customer
  orderline: Orderline
}>()

const i18n = useI18n()
</script>
